export function formatCarouselSlideAnnouncement({
    slideIndex,
    totalSlides,
    slideLabel = 'Témoignage',
    content,
}: {
    slideIndex: number
    totalSlides: number
    slideLabel?: string
    content: string
}): string {
    const position = `${slideLabel} ${slideIndex + 1} sur ${totalSlides}`
    const trimmed = content.trim()
    return trimmed ? `${position} : ${trimmed}` : position
}
